export default {
    title: "Sua experiência personalizada",
    loading1: "Configurando",
    loading2: "Analisando seus pedidos",
    loading3: "Gerando Recomendações",
};
